"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _ArticlesSection = require("./ArticlesSection");
Object.keys(_ArticlesSection).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _ArticlesSection[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _ArticlesSection[key];
        }
    });
});
var _constants = require("./constants");
Object.keys(_constants).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _constants[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _constants[key];
        }
    });
});
var _types = require("./types");
Object.keys(_types).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _types[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _types[key];
        }
    });
});
var _parseArticles = require("./parseArticles");
Object.keys(_parseArticles).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _parseArticles[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _parseArticles[key];
        }
    });
});
